module.exports = __webpack_public_path__ + "img/serious-ill.1f751b3.svg";